module.exports = __webpack_public_path__ + "img/f1.88572db0.jpg";